// extracted by css-extract-rspack-plugin
export default {"pill":"pill-AiB8wo","medium":"medium-IoAJQV","large":"large-iAPaz1","secondary":"secondary-SG1VHV","primary":"primary-IcvsvC","textGray":"textGray-Xy18ph"};